import { addDoc, collection, deleteDoc, doc, onSnapshot, query, setDoc, orderBy, getDocs } from 'firebase/firestore';
import { db } from '../../plugins/firebase';
const collectionName = "preparationPlaces";
export default {
    namespaced: true,
    state: {
        data: []
    },
    actions: {
        async load(context, payload = { refresh: true }) {
            // payloadの形式を許容（boolean または { refresh: boolean }）
            const refresh = typeof payload === 'object' && payload !== null
                ? (payload.refresh ?? true)
                : Boolean(payload);

            if (context.state.data.length === 0 || refresh) {
                let q = query(collection(db, collectionName));
                q = query(q, orderBy('id'));
                onSnapshot(q, (snapshot) => {
                    // 重複排除（id と onTheDay の組でユニーク）
                    const map = new Map();
                    snapshot.forEach((d) => {
                        const docData = d.data();
                        docData.__id = d.id;
                        docData.show = true;
                        const key = `${docData.onTheDay}-${docData.id}`;
                        map.set(key, docData);
                    });
                    context.commit('setData', Array.from(map.values()));
                });
            }
        },
        initPlace: {
            root:true,
            handler: async (context) => {await context.dispatch('load', {refresh:false})},
        },
        async update(context, item) {
            //const db = getDatabase();
            const docData = Object.assign({}, item);
            delete docData.__id;

            // データの整形
            docData.id = parseInt(docData.id);
            docData.order = parseInt(docData.order);

            if(!item.__id) {
                await addDoc(collection(db, collectionName), docData);
            }
            else {
                const ref = await doc(collection(db, collectionName), item.__id);
                await setDoc(ref, docData);
            }
        },
        async delete(context, item) {
            //const db = getDatabase();
            if(item.__id) {
                const ref = await doc(collection(db, collectionName), item.__id);
                await deleteDoc(ref);
            }
        },
        async deduplicate() {
            // id が重複しているドキュメントを整理し、各 id につき1件のみ残す
            const q = query(collection(db, collectionName), orderBy('id'));
            const snapshot = await getDocs(q);
            const idToDocs = new Map();
            snapshot.forEach((d) => {
                const data = d.data();
                const key = data.id;
                if (!idToDocs.has(key)) idToDocs.set(key, []);
                idToDocs.get(key).push(d);
            });

            const deletions = [];
            idToDocs.forEach((docs) => {
                if (docs.length > 1) {
                    // 先頭を残し、それ以外を削除
                    const [, ...dups] = docs;
                    dups.forEach((dup) => {
                        deletions.push(deleteDoc(doc(collection(db, collectionName), dup.id)));
                    });
                }
            });

            if (deletions.length > 0) {
                await Promise.all(deletions);
            }
        }
    },
    mutations: {
        setData(state, data) {
            state.data = data;
        }
    }
}